import React from 'react';
import PropTypes from 'prop-types';

import LoadingSpinner from "components/loading_spinner";
import SidebarSearch from "components/search_sidebar/sidebar_search";
import UltimatePagination from 'react-ultimate-pagination-bootstrap-3';
import SelectContacts from './select_contacts';
import { steps } from './push_contacts_constants';

import { get, post } from 'helpers/api';
import { clickAsLink } from 'helpers/link_helpers';
import _ from 'helpers/no_conflict_lodash';

import "./styles.scss";
const providerMappings = {
  "gmail": "Google",
  "outlook": "Outlook",
  "icloud": "ICloud",
  "yahoo": "Yahoo",
  "exchange": "Exchange"
};

export default class PushContacts extends React.Component {
  static propTypes = {
    editUserPath: PropTypes.string,
    email: PropTypes.string.isRequired,
    handlePushContactsPath: PropTypes.string.isRequired,
    isSameUser: PropTypes.bool,
    profileSettingsPath: PropTypes.string.isRequired,
    provider: PropTypes.string.isRequired,
    pushContactsPath: PropTypes.string.isRequired,
    user: PropTypes.object,
    onChangeBatch: PropTypes.func.isRequired,
    onChangeStep: PropTypes.func.isRequired
  }

  state = {
    contacts: [],
    allIds: [],
    currentPage: 1,
    pageSize: 25,
    totalCount: 0,
    totalPages: 0,
    loadingContacts: false,
    selectedContacts: [],
    searchText: ""
  }

  componentDidMount() {
    this.getContacts().then(() => {
      this.setState(prevState => (
        { selectedContacts: prevState.allIds }
      ));
    });
  }

  getContacts = () => {
    const { pushContactsPath } = this.props;
    const { currentPage, pageSize, searchText } = this.state;

    this.setState({ loadingContacts: true });

    return get(pushContactsPath, {
      params: {
        page: currentPage,
        pageSize: pageSize,
        searchTextCont: searchText
      }
    }).then((results) => {
      this.setState({
        ...results.meta,
        contacts: results.people,
        loadingContacts: false
      });
    });
  }
  debouncedGetContacts = _.debounce(this.getContacts, 250);

  handlePageChange = (page) => {
    this.setState({ currentPage: page }, () => {
      this.getContacts();
    });
  };

  handleSearchChange = (e) => {
    this.setState({
      searchText: e.target.value,
      currentPage: 1
    }, () => {
      this.debouncedGetContacts();
    });
  };

  handlePushContacts = () => {
    const { handlePushContactsPath, onChangeStep, onChangeBatch, user } = this.props;

    post(handlePushContactsPath, {
      contactIds: this.state.selectedContacts,
      userId: user.id
    }).then(({ batch }) => {
      onChangeStep(steps.pushContacts);
      onChangeBatch(batch);
    });
  }

  onSelectContact = (e) => {
    const contactId = parseInt(e.target.value);
    const { selectedContacts } = this.state;
    const selected = [...selectedContacts];

    const index = selected.findIndex(id => id === contactId);

    if (index >= 0) {
      selected.splice(index, 1);
    } else  {
      selected.push(contactId);
    }

    this.setState({ selectedContacts: selected });
  };

  onSelectAll = (e) => {
    const checked = e.target.checked;
    const { allIds } = this.state;
    let selectedContacts = [];

    if (checked) {
      selectedContacts = [...allIds];
    }

    this.setState({ selectedContacts: selectedContacts });
  };

  providerText = () => {
    const { email, provider } = this.props;

    const accountText = providerMappings[provider] || "Contact";
    return (
      <span>{accountText} account <strong>({email})</strong></span>
    );
  }

  render() {
    return (
      <div className="push-contacts container">
        <div className="page-header">
          <h3>
            Push Contacts
          </h3>
        </div>
        {this.renderPushContactsContainer()}
      </div>
    );
  }

  renderPushContactsContainer() {
    const { allIds, loadingContacts, provider } = this.state;

    if (allIds.length == 0 && !loadingContacts) {
      return this.renderEmptyState();
    } else {
      return (
        <div className="container merge-container white border-top-0">
          <p className="text-lg">
            The following contacts have been added to your Buildout account but are not
            current synced to {this.providerText()}. Below, check which contacts you would like to
            push to {providerMappings[provider]} to and have them start syncing.
          </p>
          {this.renderSearchBar()}
          {loadingContacts ?
            <LoadingSpinner /> :
            <React.Fragment>
              {this.renderSelectContacts()}
              {this.renderPagination()}
              {this.renderButtons()}
            </React.Fragment>
          }
        </div>
      );
    }
  }

  renderSearchBar() {
    const { searchText } = this.state;
    return (
      <SidebarSearch
        placeholder="Search contacts by name or email"
        value={searchText}
        onChange={this.handleSearchChange}
      />
    );
  }

  renderSelectContacts() {
    const { contacts, selectedContacts, totalCount } = this.state;

    return (
      <SelectContacts
        contacts={contacts}
        selectedContacts={selectedContacts}
        totalCount={totalCount}
        onSelectAll={this.onSelectAll}
        onSelectContact={this.onSelectContact}
      />
    );
  }

  renderButtons() {
    const { profileSettingsPath, editUserPath, isSameUser } = this.props;
    const { selectedContacts } = this.state;
    const cancelRoute = isSameUser ? profileSettingsPath : editUserPath;

    return (
      <div>
        <button
          className="btn btn-sm btn-cancel"
          onClick={e => clickAsLink(window, cancelRoute, e)}
        >
          Cancel
        </button>
        <button
          className="btn btn-sm btn-save left-buffer-md"
          disabled={selectedContacts.length == 0}
          name="push-contacts"
          onClick={this.handlePushContacts}
        >
          Push Contacts
        </button>
      </div>
    );
  }

  renderEmptyState() {
    return (
      <div className="container merge-container white border-top-0">
        <p className="text-lg">
          There are no available contacts to push.
        </p>
        <div>
          <button
            className='btn btn-sm btn-cancel'
          >
            Back To Integrations
          </button>
        </div>
      </div>
    );
  }

  renderPagination() {
    const { contacts, totalCount, currentPage, totalPages } = this.state;
    if (contacts.length < totalCount) {
      return (
        <div className="text-center">
          <UltimatePagination
            currentPage={currentPage}
            totalPages={totalPages}
            onChange={this.handlePageChange}
          />
        </div>
      );
    }
  }
}